<template>
  <a-tooltip placement="rightTop" @visibleChange="visibleChange">
    <template slot="title">
      <p class="tip-title">
        小组ID: {{ groupId }}
      </p>
      <a-spin :spinning="loading">
        <div class="student-list">
          <table>
            <tr v-for="(arr, index) in studentList" :key="index">
              <td v-for="stu in arr" :key="stu.id">
                {{ stu.studentName }}
              </td>
            </tr>
          </table>
        </div>
      </a-spin>
    </template>
    <a-icon type="info-circle" class="tip-icon" />
  </a-tooltip>
</template>
<script>
import { getArrGroup } from '@/utils/index'
export default {
  props: {
    // 小组Id
    groupId: Number
  },
  data() {
    return {
      studentList: [],
      loading: false
    }
  },
  methods: {
    async visibleChange(visible) {
      if (visible) {
        if (this.loading) {
          return
        }
        try {
          this.loading = true
          // 调用接口
          const res = await this.$service.groupManage.getIntragroupStudent({
            xkhTeacherCourseId: this.groupId,
            pageNum: 1,
            pageSize: 100
          })
          this.studentList = getArrGroup(res, 3)
        } catch (e) {

        } finally {
          this.loading = false
        }
      }
    }
  }
}
</script>
<style lang="less" scoped>
.tip-title {
  font-weight: 700;
  font-size: 14px;
  border-bottom: 1px solid #98A2B2;
  padding-bottom: 8px;
  margin-bottom: 8px;
}
.student-list {
  max-height: 200px;
  min-height: 20px;
  overflow-y: auto;
  &::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(172, 171, 171, 0.3);
    background-color: #F5F5F5;
  }

  &::-webkit-scrollbar {
    width: 4px;
    height: 4px;
    background-color: #F5F5F5;
  }

  &::-webkit-scrollbar-thumb{
    background-color: #b1b1b1;
  }
  table {
    width: 100%;
    tr {
      td {
        display: inline-block;
        width: 60px;
        padding-right: 8px;
        padding-bottom: 8px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 12px;
        &:last-child {
          padding-right: 0;
        }
      }
    }
  }
}
:deep(.ant-spin-dot-item) {
  background: #fff;
}
</style>